import ScrubstrApiQueryService from '../ScrubstrApiQueryService/ScrubstrApiQueryService'

export type AdminTeamMember = {
  id: string
  email: string
  name: string
  picture?: string
}

export type AdminInvite = {
  id: number
  email: string
  status: 'pending' | 'accepted' | 'revoked'
  invitedBy: string
  auth0UserId?: string
  createdAt?: string
  updatedAt?: string
}

export type AdminTeamResponse = {
  members: AdminTeamMember[]
  invites: AdminInvite[]
}

export default class AdminTeamService {
  public static async getTeam(): Promise<AdminTeamResponse> {
    const api = new ScrubstrApiQueryService()
    return api.get<AdminTeamResponse>({ endpoint: 'admin/team' })
  }

  public static async invite(email: string): Promise<AdminInvite> {
    const api = new ScrubstrApiQueryService()
    return api.post<AdminInvite>({ endpoint: 'admin/team/invite', data: { email } })
  }

  public static async resendInvite(inviteId: number): Promise<AdminInvite> {
    const api = new ScrubstrApiQueryService()
    return api.post<AdminInvite>({ endpoint: `admin/team/invite/${inviteId}/resend` })
  }

  public static async revokeInvite(inviteId: number): Promise<AdminInvite> {
    const api = new ScrubstrApiQueryService()
    return api.post<AdminInvite>({ endpoint: `admin/team/invite/${inviteId}/revoke` })
  }

  public static async removeMember(auth0UserId: string): Promise<void> {
    const api = new ScrubstrApiQueryService()
    await api.delete({ endpoint: `admin/team/member/${encodeURIComponent(auth0UserId)}` })
  }
}
